(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 1469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; },
/* harmony export */   "ac": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1720);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2067);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(6409);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs
var jsx_runtime = __webpack_require__(7320);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(8641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var dist_index_esm = __webpack_require__(7741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__(1469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 4 modules
var system_dist_index_esm = __webpack_require__(2067);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./components/next-chakra-link.tsx
var next_chakra_link = __webpack_require__(1963);
// EXTERNAL MODULE: ./lib/consts.ts + 5 modules
var consts = __webpack_require__(2256);
// EXTERNAL MODULE: ./utils/image-loader.ts
var image_loader = __webpack_require__(3600);
;// CONCATENATED MODULE: ./public/images/drop_background.jpg
/* harmony default export */ var drop_background = ({"src":"/_next/static/media/drop_background.2af3d8db.jpg","height":2048,"width":1365,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAUDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIDEQQhBRIx/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AKTOeiyow/MgjgN6JN9tC/UREH//2Q==","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./pages/index.tsx










const IndexPage = (param)=>{
    let { collections  } = param;
    const collectionsRef = (0,compat_module.useRef)(null);
    const grid = [];
    const bigImageIndex = 4;
    for(let i = 1; i < 8; i++){
        grid.push(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* GridItem */.P4, {
            display: i === bigImageIndex ? [
                "none",
                "none",
                "block"
            ] : "block",
            colSpan: i === bigImageIndex ? 2 : 1,
            position: "relative",
            h: "400px",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                quality: "40",
                sizes: "50vw",
                alt: "Collection image",
                fill: true,
                src: "/images/grid/".concat(i, ".jpg"),
                style: {
                    objectFit: "cover",
                    objectPosition: "center"
                }
            })
        }, i));
    }
    collections.filter((collection)=>{
        var ref;
        return (ref = collection.metafield) === null || ref === void 0 ? void 0 : ref.value;
    }).map((collection)=>{
        var ref, ref1;
        var ref2;
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* GridItem */.P4, {
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
                href: "/collections/" + collection.handle,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(index_esm/* Box */.xu, {
                    _hover: {
                        opacity: 0.85
                    },
                    transition: "all 0.2s",
                    cursor: "pointer",
                    h: "400px",
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            loader: image_loader/* shopifyImageLoader */.P,
                            sizes: "50vw",
                            quality: "40",
                            alt: (ref2 = (ref = collection.image) === null || ref === void 0 ? void 0 : ref.altText) !== null && ref2 !== void 0 ? ref2 : "",
                            fill: true,
                            src: (ref1 = collection.image) === null || ref1 === void 0 ? void 0 : ref1.url,
                            style: {
                                objectFit: "cover",
                                objectPosition: "center"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist_index_esm/* Button */.zx, {
                            position: "absolute",
                            top: "90%",
                            left: "50%",
                            transform: "translate(-50%, -90%)",
                            colorScheme: "cta",
                            variant: "solid",
                            children: collection.title
                        })
                    ]
                })
            })
        }, collection.id);
    }).forEach((value, i)=>{
        grid.splice(3 * i, 0, value);
    });
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
        children: consts/* ENABLE_PRODUCT_DROP */.D ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
                    title: "Blickfang",
                    openGraph: {
                        type: "website",
                        locale: "de_DE",
                        title: "Blickfang",
                        images: [
                            {
                                url: "https://blckfng.com/images/grid/1.jpg"
                            }
                        ],
                        description: "NEUE KOLLEKTION: Vorbestellungen ab jetzt m\xf6glich!"
                    },
                    twitter: {
                        cardType: "summary_large_image"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(index_esm/* VStack */.gC, {
                    spacing: 0,
                    minH: "inherit",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(HeroVideo, {
                            video: "/videos/video_400_720.mp4",
                            videoMobile: "/videos/video_mobile_350_720.mp4",
                            poster: "/videos/video_preview.png",
                            posterMobile: "/videos/video_mobile_preview.png",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* Heading */.X6, {
                                    size: "3xl",
                                    fontWeight: "900",
                                    pt: "63vh",
                                    pb: 0,
                                    children: "NEUE KOLLEKTION"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist_index_esm/* Button */.zx, {
                                    colorScheme: "cta",
                                    variant: "solid",
                                    onClick: ()=>{
                                        if (collectionsRef === null || collectionsRef === void 0 ? void 0 : collectionsRef.current) collectionsRef.current.scrollIntoView({
                                            behavior: "smooth",
                                            block: "nearest",
                                            inline: "start"
                                        });
                                    },
                                    children: "Produkte ansehen"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* Grid */.rj, {
                            ref: collectionsRef,
                            templateColumns: [
                                "repeat(2, 1fr)",
                                null,
                                "repeat(4, 1fr)"
                            ],
                            pt: "10px",
                            backgroundColor: "black",
                            w: "100%",
                            gap: "10px",
                            children: grid
                        })
                    ]
                }),
                " "
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
                    title: "Blickfang",
                    openGraph: {
                        type: "website",
                        locale: "de_DE",
                        title: "Blickfang",
                        images: [
                            {
                                url: "https://blckfng.com/images/drop_background.jpg"
                            }
                        ],
                        description: "Bestellungen werden voraussichtlich am 7.11 versendet."
                    },
                    twitter: {
                        cardType: "summary_large_image"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Hero, {
                    image: drop_background,
                    imageOpacity: 0.5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* Heading */.X6, {
                            pt: "200px",
                            pb: "20px",
                            children: "Vielen Dank f\xfcr eure Bestellungen!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(index_esm/* Text */.xv, {
                            children: [
                                "N\xe4chster Drop im Dezember.",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                "folge uns auf ",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_chakra_link/* NextChakraLink */.D, {
                                    textDecorationStyle: "dotted",
                                    textDecoration: "underline",
                                    href: "https://instagram.com/blickfang_de",
                                    children: "Instagram"
                                }),
                                " f\xfcr aktuelle Informationen!"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const Hero = (param)=>{
    let { image , imageOpacity , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(index_esm/* Box */.xu, {
        w: "100%",
        minH: "inherit",
        position: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* Box */.xu, {
                position: "absolute",
                opacity: imageOpacity,
                left: "0",
                top: "0",
                w: "100%",
                zIndex: -1,
                h: "100vh",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    priority: true,
                    quality: 70,
                    fill: true,
                    alt: "Hero image",
                    src: image,
                    placeholder: "blur",
                    style: {
                        objectFit: "cover"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* Center */.M5, {
                position: "relative",
                p: "10px",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* VStack */.gC, {
                    textAlign: "center",
                    children: children
                })
            })
        ]
    });
};
const HeroVideo = (param)=>{
    let { videoMobile , video , poster , posterMobile , children  } = param;
    const [isLargerThan600] = (0,media_query_dist_index_esm/* useMediaQuery */.ac)("(min-width: 600px)", {
        ssr: true,
        fallback: false
    });
    const videoRef = (0,compat_module.useRef)(null);
    (0,compat_module.useEffect)(()=>{
        var ref;
        (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.load();
    }, [
        isLargerThan600
    ]);
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(index_esm/* Box */.xu, {
        w: "100%",
        minH: "inherit",
        position: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* Box */.xu, {
                position: "absolute",
                left: "0",
                top: "0",
                w: "100%",
                zIndex: -1,
                h: "100vh",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(system_dist_index_esm/* chakra.video */.m$.video, {
                    poster: isLargerThan600 ? poster : posterMobile,
                    ref: videoRef,
                    objectFit: "cover",
                    minHeight: "100%",
                    minWidth: "100%",
                    autoPlay: true,
                    loop: true,
                    muted: true,
                    playsInline: true,
                    children: [
                        isLargerThan600 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("source", {
                            src: video,
                            type: "video/mp4"
                        }),
                        !isLargerThan600 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("source", {
                            src: videoMobile,
                            type: "video/mp4"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* Center */.M5, {
                position: "relative",
                p: "10px",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* VStack */.gC, {
                    textAlign: "center",
                    children: children
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (IndexPage);


/***/ }),

/***/ 3600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ shopifyImageLoader; }
/* harmony export */ });
const shopifyImageLoader = (param)=>{
    let { src , width  } = param;
    if (src.startsWith("https://cdn.shopify.com")) {
        return "".concat(src, "&width=").concat(width);
    } else return src;
};



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,962,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);